define('lq/licquidRuntimeRaven',[],function () {
    
    var LicquidRuntimeRaven = function (licquidRuntime) {
        this.licquidRuntime = licquidRuntime;
    };

    LicquidRuntimeRaven.prototype.start = function (setup) {
        var self = this;
        var raven = setup.raven;
        var licquidRuntime = this.licquidRuntime;
        require(['raven'], function (Raven) {
            Raven
                .config(raven.frontEndDsn,
                    {
                        tags: raven.tags,
                        dataCallback: function (data) {
                            data.fingerprint = raven.tags.issuesProjectIdentifier
                                ? ['{{ default }}', raven.tags.issuesProjectIdentifier, raven.tags.rootMorphId]
                                : ['{{ default }}', raven.tags.tenant, raven.tags.application, raven.tags.rootMorphId];

                            if (licquidRuntime.action) {
                                data.extra.globalParameters = licquidRuntime.action.piping.parameters.globals.getAll();
                                data.extra.localParameters = licquidRuntime.action.piping.parameters.locals.getAll();
                                data.tags.rootMorphId = licquidRuntime.action.data.id;
                                data.extra.bookmark = {
                                    bookmarkType: 'actionBookmarkById',
                                    rootMorphId: licquidRuntime.action.data.id
                                }
                            }

                            if (licquidRuntime.globalPiping) {
                                var application = licquidRuntime.globalPiping.application;
                                if (application.releaseName)
                                    data.tags.releaseNumber = application.releaseName;
                                if (application.userId)
                                    data.user = {
                                        id: application.userId
                                    }
                            }
 
                            return data;
                        }
                    })
                .install();

            Raven.context(self.startRuntime.bind(self, setup));
        });
    };

    LicquidRuntimeRaven.prototype.startRuntime = function (setup) {
        this.licquidRuntime.start(setup);
    };

    return LicquidRuntimeRaven;
});
